import {
    ADD_USER_PREFERENCE_REQUEST,
    REMOVE_USER_PREFERENCE_REQUEST,
    ADD_USER_PREFERENCE_SUCCESS,
    REMOVE_USER_PREFERENCE_SUCCESS,
    ADD_USER_PREFERENCE_ERROR,
    REMOVE_USER_PREFERENCE_ERROR,
} from '../constants/ActionTypes';

export default function userPreferenceUpdating(state = false, { type }) {
    switch (type) {
        case ADD_USER_PREFERENCE_REQUEST:
        case REMOVE_USER_PREFERENCE_REQUEST:
            return true;

        case ADD_USER_PREFERENCE_SUCCESS:
        case REMOVE_USER_PREFERENCE_SUCCESS:
        case ADD_USER_PREFERENCE_ERROR:
        case REMOVE_USER_PREFERENCE_ERROR:
            return false;

        default:
            return state;
    }
}
